// extracted by mini-css-extract-plugin
export var calendarView = "_lc-0";